// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"_36ua3","tag-element":"_1xi6c"};